export function AppFooter() {
  return <footer className='h-12 bg-slate-800'></footer>;
}
